import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './Founder.module.css';
import Eyebrow from '../ui/Eyebrow';

export default function Founder() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <section className={styles.founder} id="founder" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow>FOUNDER</Eyebrow>
        <h2 className={styles.heading}>Omari Sanders</h2>
        <div className={styles.content}>
          <div className={styles.role}>FOUNDER &middot; INFUNDRA</div>
          <div className={styles.bio}>
            <p>Omari Sanders is a software architect and technical founder with over two decades of experience building technology across the private sector, nonprofit, and federal government. He built infundra to give domain-expert operators the enterprise-grade infrastructure they need without the cost and complexity of building it themselves.</p>
          </div>
          <a href="https://omarisanders.com" target="_blank" rel="noopener noreferrer" className={styles.contact}>
            omarisanders.com &rarr;
          </a>
        </div>
      </motion.div>
    </section>
  );
}
